import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth auth--test-acces auth--bg-second" }
const _hoisted_2 = { class: "g-container g-container--fit_main-width relative relative--align_center" }
const _hoisted_3 = { class: "flying-logo" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "logo__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo__img",
    width: "82",
    height: "82",
    src: "/static/app/mob-logo.svg",
    alt: "hq vpn logo",
    title: ""
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "logo__text logo__text--main-size" }, "HQ VPN", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "g-container g-container--fit_main-width g-container--space_special relative relative--align_center" }
const _hoisted_9 = { class: "auth-form auth-form--test-access auth-form--space-md auth-form--width_sm" }
const _hoisted_10 = { class: "auth-form__inner" }
const _hoisted_11 = { class: "auth-form__title auth-form__title--special" }
const _hoisted_12 = { class: "ds-panel ds-panel--space_3xl ds-panel--space_none-xl" }
const _hoisted_13 = { class: "ds-panel__element ds-panel__element--offset_bottom" }
const _hoisted_14 = { class: "ds-caption ds-caption--size_2md ds-caption--size_5xl-xl ds-caption--bold ds-caption--color_dark-blue ds-caption--appearance_center" }
const _hoisted_15 = { class: "auth-form__wrapper" }
const _hoisted_16 = { class: "payment-page-wrapper" }
const _hoisted_17 = { class: "payment-page-btns" }
const _hoisted_18 = { class: "g-row g-row--appearance_spaced g-row--space_lg g-row--space_2xl-xl g-row--justify_center" }
const _hoisted_19 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold ds-caption--size_2md" }
const _hoisted_22 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-xl" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "hq-btn__text ds-caption ds-caption--color_white ds-caption--bold ds-caption--size_2md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "logo link",
          href: $setup.indexPage,
          target: "_self"
        }, _hoisted_7, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        ($setup.load)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h1", _hoisted_14, _toDisplayString($setup.$t("Что-то пошло не так, платеж был отменен...")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("a", {
                      class: "hq-btn hq-btn--simple-blue hq-btn--centered hq-btn--full_width hq-btn--full_height-xl hq-btn--br-radius_main hq-btn--shadowed-main",
                      href: $setup.getOrderUrl()
                    }, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString($setup.$t("Другой способ оплаты")), 1)
                    ], 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("a", {
                      class: "hq-btn hq-btn--auth-style-green hq-btn--centered hq-btn--br-radius_main hq-btn--full_width hq-btn--full_height-xl hq-btn--shadowed-main",
                      href: $setup.getPaymentUrl()
                    }, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString($setup.$t('Попробовать еще раз')), 1)
                    ], 8, _hoisted_23)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}